/**
 * Source-of-truth list of Delapresse sub-processors.
 *
 * Rendered in two places:
 *   - /trust    (legal page, formal language, Art. 28 RGPD context)
 *   - /securite (marketing security page, badges + downloads)
 *
 * Keep this list aligned with the /trust legal copy whenever you onboard or
 * offboard a sub-processor. Notify customers per the DPA clauses.
 */

export interface Subprocessor {
  name: string;
  country: string;
  purpose: string;
  data: string;
  basis: string;
  dpa: string;
}

export const SUBPROCESSORS: Subprocessor[] = [
  {
    name: "Supabase",
    country: "EU (Frankfurt) / US (corporate)",
    purpose: "Database, Auth, Storage, Edge Functions",
    data: "Account, content, media, logs",
    basis: "DPA + SCC 2021/914",
    dpa: "https://supabase.com/legal/dpa",
  },
  {
    name: "Stripe",
    country: "Ireland (EU) / United States",
    purpose: "Payment processing",
    data: "Email, name, billing address, last 4",
    basis: "DPA + SCC 2021/914",
    dpa: "https://stripe.com/legal/dpa",
  },
  {
    name: "Google (Gemini API)",
    country: "United States",
    purpose: "AI article rewriting + image generation",
    data: "Article text submitted to AI tools",
    basis: "SCC 2021/914 + opt-in consent",
    dpa: "https://cloud.google.com/terms/data-processing-addendum",
  },
  {
    name: "Perplexity",
    country: "United States",
    purpose: "News research",
    data: "Search queries",
    basis: "SCC 2021/914",
    dpa: "https://www.perplexity.ai/hub/legal/data-processing-addendum",
  },
  {
    name: "Resend",
    country: "United States",
    purpose: "Transactional email (verification, password reset, invoices)",
    data: "Email, name, message bodies",
    basis: "SCC 2021/914",
    dpa: "https://resend.com/legal/dpa",
  },
  {
    name: "Plesk hosting provider",
    country: "France / EU (customer-selected)",
    purpose: "Managed site hosting per subscription",
    data: "Site content (under customer control)",
    basis: "Sub-processor agreement",
    dpa: "—",
  },
];
